module.exports = __webpack_public_path__ + "img/big4-12.a03154aa.jpg";